module.exports = __webpack_public_path__ + "img/ic_publicity_detail2_1.053e4872.jpg";